import { Spinner, SpinnerProps } from '@fluentui/react-components';

export const Loader = (props: Partial<SpinnerProps>) => <Spinner {...props} style={{ position: 'fixed' }} />;
